import { makeStyles } from "@fluentui/react-components";

export const useForgotPasswordStyles = makeStyles({
  dialogTitle: { display: "flex", alignItems: "center", justifyContent: "space-between" },
});
